export default __webpack_public_path__ + "static/media/PlasmaDonorRegistration.ad43a71f.svg";